let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8URoA")).then(() => parcelRequire('rTIh7'));